import React, { useState, useEffect } from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import for_me from "../../assets/images/covert_art/for_me.png";
import for_me_video from "../../assets/videos/FOR_ME_VISUALIZER.mp4";
import "../../assets/styles/NewestSingle.css";

export default function NewestSingle() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsModalOpen(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = "unset";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isModalOpen]);

  return (
    <MDBContainer id="newest_single" className="newest-single-container" fluid>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "50vh", textAlign: "center" }}>

        {/* Cover Art Wrapper with Hover Effect and Play Overlay */}
        <div
          className="cover-art-wrapper"
          onClick={() => setIsModalOpen(true)}
          style={{ cursor: "pointer", position: "relative", overflow: "hidden", borderRadius: "12px", boxShadow: "0 8px 24px rgba(0,0,0,0.3)", marginBottom: "20px" }}
        >
          <img
            src={for_me}
            alt="FOR ME"
            className="too-hot-img"
          />
          <div className="play-overlay">
            <svg viewBox="0 0 24 24" width="48" height="48" fill="white" className="play-icon-svg">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>

        <div className="newest-single-header">
          <a
            href="https://distrokid.com/hyperfollow/tiro9/for-me"
            target="_blank"
            rel="noopener noreferrer"
            className="newest-single-link"
          >
            "FOR ME" OUT NOW!
          </a>
        </div>
      </div>

      {/* Modal Dialog */}
      {isModalOpen && (
        <div className="custom-modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="custom-modal-close" onClick={() => setIsModalOpen(false)} aria-label="Close dialog">
              &times;
            </button>
            <div className="custom-modal-body">
              {/* Left Column: Video */}
              <div className="custom-modal-video-wrapper">
                <video
                  src={for_me_video}
                  controls
                  autoPlay
                  playsInline
                  className="custom-modal-video"
                />
              </div>

              {/* Right Column: Text Information */}
              <div className="custom-modal-info">
                <h3 className="modal-title">FOR ME</h3>
                <h4 className="modal-subtitle">TIRO</h4>

                <p className="modal-paragraph">
                  “For me” is TIRO’s Afrobeats single, running two minutes and one second with no features. The song lives in that moment where attraction is obvious before anyone says it out loud. He watches her move, calls her body a symphony, and admits he fell for the spell and can’t refuse. The rest plays out as a back and forth: put my name on your phone, pull up on me, I see your eyes on me.
                </p>
                <p className="modal-paragraph">
                  The delivery is melodic and conversational, sliding between English and pidgin phrasing in a way that reads Toronto and Lagos at the same time, which matches where his listeners actually are. The “jo jo jo” run and the repeated “I see your eyes on me” section give it two separate hooks in a track most artists would use for one.
                </p>
                <p className="modal-paragraph">
                  The single follows TIRO’s rebrand from Tirothetyrant and a catalogue that includes “Heaven Sent” and “Too Hot.” It carries 100% Canadian Content certification under MAPL.
                </p>

                <div className="modal-release-date">
                  <a
                    href="https://distrokid.com/hyperfollow/tiro9/for-me"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="modal-release-link"
                  >
                    OUT NOW!
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </MDBContainer>
  );
}


